import Cookies from 'js-cookie';

function makeAddressStr(address) {
  const addressFieldComp = [
    'field_address_line1',
    'field_address_line2',
    'field_address_locality',
    'field_address_administrative_area',
    'field_address_postal_code',
  ];
  const addressObj = JSON.parse(address);
  const addressStr = addressFieldComp
    .map((f) => addressObj[f])
    .filter((val) => val)
    .join(', ');

  return addressStr;
}

export default function createCompanyContacts(
  address,
  email,
  phone,
  site,
  analytics,
) {
  const customerType = Cookies.get('customer_type');
  const contacts = [
    address && {
      icon: 'pin-thin',
      text: makeAddressStr(address),
      type: 'address',
    },
    email && {
      icon: 'mail',
      text: email,
      url: `mailto:${email}`,
      type: 'email',
    },
    phone && {
      icon: 'phonecall',
      text: phone,
      url: `tel:${phone}`,
      type: 'phone',
      analyticsClickPush: analytics?.vendor_called
        ? {
            ...analytics.vendor_called,
            customer_type: customerType || 'null',
          }
        : null,
    },
    site && {
      icon: 'globe',
      text: site,
      url: site,
      type: 'site',
      analyticsClickPush: analytics?.vendor_website_clicked
        ? analytics.vendor_website_clicked
        : null,
    },
  ];
  return contacts.filter((v) => v);
}
